(function () {
  'use strict';

  /**
   * TCB GA4 / GTM event helper. Pushes to dataLayer when present.
   * See docs/TCB-ECOSYSTEM-ROADMAP.md §12 Metrics.
   */
  function track(event, params) {
    if (!event) return;
    var payload = Object.assign({ event: event }, params || {});
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, params || {});
    }
    if (window.tcbAnalyticsDebug) {
      try {
        console.info('[tcbAnalytics]', payload);
      } catch (e) { /* ignore */ }
    }
  }

  window.tcbAnalytics = {
    track: track,
    finderStarted: function () { track('finder_started'); },
    finderCompleted: function (answers) {
      track('finder_completed', {
        facility: answers && answers.facility || '',
        equipment: answers && answers.equipment || '',
        budget: answers && answers.budget || ''
      });
    },
    finderEmailCaptured: function (email) {
      track('finder_email_captured', { has_email: !!email });
    },
    packageAddAllClicked: function (packageId, itemCount) {
      track('package_add_all_clicked', {
        package_id: packageId || '',
        item_count: itemCount || 0
      });
    },
    packageTermsChecked: function (packageId) {
      track('package_terms_checked', { package_id: packageId || '' });
    },
    packageViewed: function (data) { track('package_viewed', data); },
    packageAddAllSuccess: function (data) { track('package_add_all_success', data); },
    packageAddAllFailed: function (data) { track('package_add_all_failed', data); },
    packageQuoteClicked: function (data) { track('package_quote_clicked', data); },
    packageExpertClicked: function (data) { track('package_expert_clicked', data); },
    packageAddonSelected: function (data) { track('package_addon_selected', data); },
    packageAddonAdded: function (data) { track('package_addon_added', data); },
    quoteRequested: function (source, topic) {
      track('quote_requested', { source: source || 'unknown', topic: topic || '' });
    },
    formSubmitted: function (source, topic) {
      track('form_submitted', { form_source: source || 'unknown', topic: topic || '' });
    },
    newsletterSubscribed: function (source) {
      track('newsletter_subscribed', { source: source || 'footer' });
    },
    addToCart: function (data) {
      track('add_to_cart', {
        variant_id: (data && data.variant_id) || '',
        quantity: (data && data.quantity) || 1,
        source: (data && data.source) || 'unknown'
      });
    },
    advisorOpened: function (data) {
      track('advisor_opened', {
        source: (data && data.source) || 'unknown',
        placement: (data && data.placement) || ''
      });
    },
    finderOpened: function (data) {
      track('finder_opened', { source: (data && data.source) || 'unknown' });
    }
  };
})();
